<!-- お知らせ詳細 -->
<template>
  <div>
    <!-- 表头文字 -->
    <el-row :gutter="0" style="margin-top:8px">
      <!-- お知らせ -->
      <div class="table-header">{{$t('MODULE.B0001_LBL_INFORM')}}</div>
    </el-row>
    <table class="b0002-table table-label">
      <tr>
        <!-- 配信者： -->
        <td class="b0002-form-label">{{$t('MODULE.B0002_LBL_MAILSENDUSER')}}&nbsp;</td>
        <td class="b0002-form-value">
          <!-- 高 -->
          <span>{{tNoticeDetail.mailSendUserName}}</span>
        </td>
      </tr>
      <tr>
        <!-- 配信時間：-->
        <td class="b0002-form-label">{{$t('MODULE.B0002_LBL_MAILDATE')}}&nbsp;</td>
        <td class="b0002-form-value">
          <span>{{tNoticeDetail.mailDate}}</span>
        </td>
      </tr>
      <tr>
        <!-- タイトル： -->
        <td class="b0002-form-label">{{$t('MODULE.B0002_LBL_MAILTITLE')}}&nbsp;</td>
        <td class="b0002-form-value">
          <span>{{tNoticeDetail.mailTitle}}</span>
        </td>
      </tr>
      <tr>
        <!-- 内容： -->
        <td class="b0002-form-label">{{$t('MODULE.B0002_LBL_MAILATTACHMENT')}}&nbsp;</td>
        <td class="b0002-form-value">
          <div v-html="tNoticeDetail.mailContents.replaceAll('\n','<br />')"></div>
        </td>
      </tr>
      <tr>
        <!-- リンク： -->
        <td class="b0002-form-label">{{$t('MODULE.B0002_LBL_LINK')}}&nbsp;</td>
        <td class="b0002-form-value">
          <div :style="{height:linkHeight*linkRow+'px'}">
            <a :style="{color:alinkColor}" @click="hrefColorChange" :href="checkUrl(tNoticeDetail.attachmentLink)" target="blank">{{attachmentLinkShow}}</a>
          </div>
        </td>
      </tr>
      <tr>
        <!-- ファイル： -->
        <td class="b0002-form-label">{{$t('MODULE.B0002_LBL_FILE')}}&nbsp;</td>
        <td class="b0002-form-value">
          <div v-for='(item,key) in fileList' :key="item.key">
            <div class="b0002-mailAttachment" @click="download(item)"><i class="el-icon-document" />
              <!-- 字体使用a标签的蓝色样式 -->
              <a href="#">{{item.name}}</a>
            </div>
          </div>
        </td>
      </tr>
    </table>
    <div class="b0002btn-center">
      <!-- 戻る -->
      <el-button class="css-btn css-button" style="margin-top: 8px;font-size: 10pt;" type="primary" @click="back">{{$t('MODULE.B0002_LBL_BACK')}}</el-button>
    </div>
  </div>
</template>
<script>
import css from "@/statics/css"
import utilApi from '@/common/utils'
import * as amsApi from "../api/b_0002"
export default {
  mixins: [css],
  name: '',
  components: {

  },
  data() {
    return {
      userCd: '',
      noticeCd: '',
      tNoticeDetail: {
        mailContents: ''
      },
      fileList: [],
      pdfUrl: '',
      linkHeight: 27,
      linkRow: 1,
      attachmentLinkShow: '',
      alinkColor: 'blue',
    }
  },
  created() {
    this.userCd = this.$route.query.userCd
    this.noticeCd = this.$route.query.noticeCd
    this.query()
  },
  methods: {
    query() {
      //实现Loading 加载方法
      this.set_loading()
      amsApi.noticeDetailGet(this.userCd, this.noticeCd).then(res => {
        this.tNoticeDetail = res.items.tNoticeDetail[0]
        if (!this.tNoticeDetail) {
          return
        }
        if (this.tNoticeDetail.attachmentLink) {
          this.linkRow = Math.ceil(this.tNoticeDetail.attachmentLink.length / 30)
          if (this.tNoticeDetail.attachmentLink.length >= 90) {
            this.attachmentLinkShow = this.tNoticeDetail.attachmentLink.substring(0, 90) + '...'
            this.linkRow = 3
          } else {
            this.attachmentLinkShow = this.tNoticeDetail.attachmentLink
          }
        }
        if (this.tNoticeDetail.mailDate) {
          this.tNoticeDetail.mailDate = utilApi.timeDefault(this.tNoticeDetail.mailDate)
        }
        this.fileList = []
        if (this.tNoticeDetail.mailAttachment) {
          this.fileQuery()
        } else {
          this.close_loading()
        }
      }).catch((err) => {
        this.close_loading()
      });
    },
    // 打开URL栏中入力的连接
    checkUrl(val) {
      if (val) {
        var addr1 = val.substr(0, 7).toLowerCase();
        var addr2 = val.substr(0, 8).toLowerCase();
        if (addr1 == 'http://' || addr2 == 'https://') {
          return val
        } else {
          return 'http://' + val
        }
      }
    },
    // 点击URL后将URL颜色调整为紫色
    hrefColorChange() {
      this.alinkColor = '#551A8B'
    },
    //文件查询
    fileQuery() {
      var _fileList = []
      this.blobFile = {};
      // 获取文件名_fileList，并去重
      for (var item of this.tNoticeDetail.mailAttachment.split(',')) {
        if (_fileList.indexOf(item) == -1) {
          _fileList.push(item)
        }
      }
      for (var i = 0; i < _fileList.length; i++) {
        //ファイル名取得
        var fileName = _fileList[i].split('/')[_fileList[i].split('/').length - 1];
        var PathfileName = _fileList[i];
        this.blobFile[fileName] = PathfileName;
      }
      var photoSum = 0
      for (var key in this.blobFile) {
        var getFileImageParams = {};
        getFileImageParams.filePath = this.blobFile[key];
        getFileImageParams.resizeCd = '0'
        let fileUrl = {};
        fileUrl.name = key;
        amsApi.b_0002_getFile(getFileImageParams).then(res_file => {
          let blob = new Blob([res_file], { type: 'application/octet-stream;charset=UTF-8' })
          let url = window.URL.createObjectURL(blob);
          fileUrl.url = url;
          fileUrl.file = res_file;
          if (fileUrl.name.indexOf("%26") !== -1) {
            fileUrl.name = fileUrl.name.replace('%26', '&')
          }
          if (fileUrl.name.indexOf("%2F") !== -1) {
            fileUrl.name = fileUrl.name.replace('%2F', '/')
          }
          if (fileUrl.name.indexOf("%3F") !== -1) {
            fileUrl.name = fileUrl.name.replace('%3F', '?')
          }
          if (fileUrl.name.indexOf("%23") !== -1) {
            fileUrl.name = fileUrl.name.replace('%23', '#')
          }
          if (fileUrl.name.indexOf("%25") !== -1) {
            fileUrl.name = fileUrl.name.replace('%25', '%')
          }
          this.fileList.push(fileUrl);

          photoSum += 1
          if (photoSum == _fileList.length) {
            this.close_loading()
          }
        }).catch((err) => {
          //关闭loading
          this.close_loading()
        });
      }
    },

    //ファイルをダウンロード
    download(file) {
      let fileTypeMime = ''; // 文件mime类型
      let fileName = file.name;
      let suffix = fileName.substring(fileName.lastIndexOf('.') + 1)//获得文件后缀
      switch (suffix) { // switch获取后缀对应的mime
        case 'png': fileTypeMime = 'image/png'; break;
        case 'doc': fileTypeMime = 'application/msword'; break;
        case 'docx': fileTypeMime = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'; break;
        case 'jpg': case 'jpeg': fileTypeMime = 'image/jpeg'; break;
        case 'gif': fileTypeMime = 'image/gif'; break;
        case 'svg': fileTypeMime = 'image/svg+xml'; break;
        case 'txt': fileTypeMime = 'text/plain'; break;
        case 'ppt': fileTypeMime = 'application/vnd.ms-powerpoint'; break;
        case 'xls': fileTypeMime = 'application/vnd.ms-excel'; break;
        case 'xlsx': fileTypeMime = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; break;
        case 'pdf': fileTypeMime = 'application/pdf'; break;
      }
      let content = file.file;//arraybuffer类型数据
      let resBlob = new Blob([content])
      let reader = new FileReader()
      reader.readAsText(resBlob, 'UTF-8')
      reader.onload = (evt) => {
        let blob;
        if (suffix == 'txt') {
          blob = new Blob(['\uFEFF' + evt.target.result], { type: fileTypeMime });
        } else {
          blob = new Blob([file.file], { type: fileTypeMime });
        }
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a')
        a.style.display = 'none'
        a.download = file.name
        a.href = blobUrl
        a.click()
      };
    },

    //返回
    back() {
      this.$router.go(-1)
    },
  }
}
</script>
<style>
/* 表格边框、字体样式 */
.b0002-table {
  border-collapse: collapse;
  width: 100%;
}
/* 表格边框颜色 */
.b0002-table,
.b0002-table tr td {
  line-height: 2;
  border: 1px solid #ccc;
}
/* 表格内边距 */
.b0002-form-value {
  padding: 5px 8px;
}
/* 表格第一列背景色、宽度、文字居右 */
.b0002-form-label {
  text-align: right;
  width: 110px;
  background: #d2eef8;
}
/* 表格第二列背景色 */
.b0002-form-value {
  background: #fafafa;
}
.b0002-table table {
  table-layout: fixed;
}
.b0002-table td {
  word-break: break-all;
  word-wrap: break-word;
}

/* 保存按钮自适应居中 */
.b0002btn-center {
  padding-top: 10px;
  text-align: center;
  width: 100%;
  height: 100%;
  margin: 0px;
}
.b0002-mailAttachment {
  word-break: break-all;
  width: auto;
  display: block;
  white-space: pre-wrap;
}

.pdfDialog .el-dialog__wrapper {
  background-color: rgb(114, 114, 114);
}
.currentPage {
  cursor: pointer;
  color: #8c8e92;
}

.currentPage:hover {
  color: #2761ff;
}

.arrow {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 2;
  width: 100%;
  background-color: #191919;
  padding: 12px 0;
  margin: 0;
  text-align: center;
}

.el-dialog__body {
  color: #606266;
  font-size: 14px;
  padding: 0;
}
a {
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/module/page/b_0002.vue